const switchPostsToListMode = () =>
  new Promise(resolve => {
    window.dispatchEvent(
      new CustomEvent('gestodo:posts:set-layout', {
        detail: { layout: 'list' }
      })
    );
    window.setTimeout(resolve, 150);
  });

const selectFirstPostForTour = selected =>
  new Promise(resolve => {
    window.dispatchEvent(
      new CustomEvent('gestodo:posts:select-first', {
        detail: { selected }
      })
    );
    window.setTimeout(resolve, 150);
  });

const dispatchTourEvent = (eventName, detail = {}, delay = 180) =>
  new Promise(resolve => {
    window.dispatchEvent(new CustomEvent(eventName, { detail }));
    window.setTimeout(resolve, delay);
  });

const setQuestionsTourTab = tab =>
  dispatchTourEvent('gestodo:questions:set-tab', { tab }, 450);

const setAnalisisTourTab = tab =>
  dispatchTourEvent('gestodo:analisis:set-tab', { tab }, 250);

const setPriceCalculatorSaveTab = tab =>
  dispatchTourEvent('gestodo:price-calculator:set-save-tab', { tab }, 180);

const openCalendarEventModal = () =>
  dispatchTourEvent('gestodo:calendar:open-create-event', {}, 250);

const closeCalendarEventModal = () =>
  window.dispatchEvent(new CustomEvent('gestodo:calendar:close-event-modal'));

const openMessagesComposeModal = () =>
  dispatchTourEvent('gestodo:messages:open-compose', { mode: 'direct' }, 250);

const closeMessagesComposeModal = () =>
  window.dispatchEvent(new CustomEvent('gestodo:messages:close-compose'));

const openAccessUserModal = () =>
  dispatchTourEvent('gestodo:access:open-user-modal', {}, 250);

const closeAccessUserModal = () =>
  window.dispatchEvent(new CustomEvent('gestodo:access:close-user-modal'));

const HELP_MODULES = [
  {
    key: 'dashboard',
    titleKey: 'MAIN.DASHBOARD',
    descriptionKey: 'HELP_CENTER.MODULES.DASHBOARD.DESCRIPTION',
    route: '/dashboard',
    routePrefixes: ['/dashboard'],
    icon: 'chart-pie',
    requiredPermission: 'dashboard.view',
    modes: ['gestion'],
    tourReadySelector: '[data-tour-ready="dashboard"]',
    sections: [
      'HELP_CENTER.MODULES.DASHBOARD.SECTIONS.READ_SIGNALS',
      'HELP_CENTER.MODULES.DASHBOARD.SECTIONS.FOLLOW_TRENDS',
      'HELP_CENTER.MODULES.DASHBOARD.SECTIONS.ACT_ON_INSIGHTS'
    ],
    tourSteps: [
      {
        target: '[data-tour="dashboard-header"]',
        titleKey: 'HELP_CENTER.TOUR.DASHBOARD.HEADER_TITLE',
        contentKey: 'HELP_CENTER.TOUR.DASHBOARD.HEADER_CONTENT',
        placement: 'bottom',
        skipBeacon: true
      },
      {
        target: '[data-tour="dashboard-filters"]',
        titleKey: 'HELP_CENTER.TOUR.DASHBOARD.FILTERS_TITLE',
        contentKey: 'HELP_CENTER.TOUR.DASHBOARD.FILTERS_CONTENT',
        placement: 'bottom'
      },
      {
        target: '[data-tour="dashboard-insights"]',
        titleKey: 'HELP_CENTER.TOUR.DASHBOARD.INSIGHTS_TITLE',
        contentKey: 'HELP_CENTER.TOUR.DASHBOARD.INSIGHTS_CONTENT',
        placement: 'bottom'
      },
      {
        target: '[data-tour="dashboard-metrics"]',
        titleKey: 'HELP_CENTER.TOUR.DASHBOARD.METRICS_TITLE',
        contentKey: 'HELP_CENTER.TOUR.DASHBOARD.METRICS_CONTENT',
        placement: 'bottom'
      },
      {
        target: '[data-tour="dashboard-account-health"]',
        titleKey: 'HELP_CENTER.TOUR.DASHBOARD.ACCOUNT_TITLE',
        contentKey: 'HELP_CENTER.TOUR.DASHBOARD.ACCOUNT_CONTENT',
        placement: 'top'
      }
    ]
  },
  {
    key: 'questions',
    titleKey: 'MAIN.QUESTIONS',
    descriptionKey: 'HELP_CENTER.MODULES.QUESTIONS.DESCRIPTION',
    route: '/questions',
    routePrefixes: ['/questions'],
    icon: 'question-circle',
    requiredPermission: 'questions.view',
    modes: ['gestion'],
    tourReadySelector: '[data-tour-ready="questions"]',
    sections: [
      'HELP_CENTER.MODULES.QUESTIONS.SECTIONS.REVIEW_PENDING',
      'HELP_CENTER.MODULES.QUESTIONS.SECTIONS.ANSWER_INLINE',
      'HELP_CENTER.MODULES.QUESTIONS.SECTIONS.USE_CONTEXT'
    ],
    tourSteps: [
      {
        target: '[data-tour="questions-tabs"]',
        titleKey: 'HELP_CENTER.TOUR.QUESTIONS.TABS_TITLE',
        contentKey: 'HELP_CENTER.TOUR.QUESTIONS.TABS_CONTENT',
        placement: 'bottom',
        skipBeacon: true,
        before: () => setQuestionsTourTab('unanswered')
      },
      {
        target: '[data-tour="questions-unanswered-list"]',
        titleKey: 'HELP_CENTER.TOUR.QUESTIONS.UNANSWERED_TITLE',
        contentKey: 'HELP_CENTER.TOUR.QUESTIONS.UNANSWERED_CONTENT',
        placement: 'bottom'
      },
      {
        target: '[data-tour="questions-first-card"]',
        titleKey: 'HELP_CENTER.TOUR.QUESTIONS.CARD_TITLE',
        contentKey: 'HELP_CENTER.TOUR.QUESTIONS.CARD_CONTENT',
        placement: 'bottom'
      },
      {
        target: '[data-tour="questions-card-actions"]',
        titleKey: 'HELP_CENTER.TOUR.QUESTIONS.ACTIONS_TITLE',
        contentKey: 'HELP_CENTER.TOUR.QUESTIONS.ACTIONS_CONTENT',
        placement: 'left'
      },
      {
        target: '[data-tour="questions-all-filters"]',
        titleKey: 'HELP_CENTER.TOUR.QUESTIONS.FILTERS_TITLE',
        contentKey: 'HELP_CENTER.TOUR.QUESTIONS.FILTERS_CONTENT',
        placement: 'bottom',
        before: () => setQuestionsTourTab('all')
      },
      {
        target: '[data-tour="questions-table-question"]',
        titleKey: 'HELP_CENTER.TOUR.QUESTIONS.TABLE_TITLE',
        contentKey: 'HELP_CENTER.TOUR.QUESTIONS.TABLE_CONTENT',
        placement: 'bottom',
        before: () => setQuestionsTourTab('all')
      },
      {
        target: '[data-tour="questions-table-actions"]',
        titleKey: 'HELP_CENTER.TOUR.QUESTIONS.TABLE_ACTIONS_TITLE',
        contentKey: 'HELP_CENTER.TOUR.QUESTIONS.TABLE_ACTIONS_CONTENT',
        placement: 'left',
        before: () => setQuestionsTourTab('all')
      }
    ]
  },
  {
    key: 'messages',
    titleKey: 'MAIN.MESSAGES',
    descriptionKey: 'HELP_CENTER.MODULES.MESSAGES.DESCRIPTION',
    route: '/messages',
    routePrefixes: ['/messages', '/mercadolibre-messages'],
    icon: 'comments',
    requiredAnyPermissions: ['messages.view_internal', 'messages.view_mercadolibre'],
    modes: ['gestion'],
    tourReadySelector: '[data-tour-ready="messages"]',
    sections: [
      'HELP_CENTER.MODULES.MESSAGES.SECTIONS.OPEN_INBOX',
      'HELP_CENTER.MODULES.MESSAGES.SECTIONS.TRACK_CONVERSATIONS',
      'HELP_CENTER.MODULES.MESSAGES.SECTIONS.REPLY_WITH_CONTEXT'
    ],
    tourSteps: [
      { target: '[data-tour="messages-header"]', titleKey: 'HELP_CENTER.TOUR.MESSAGES.HEADER_TITLE', contentKey: 'HELP_CENTER.TOUR.MESSAGES.HEADER_CONTENT', placement: 'bottom', skipBeacon: true },
      { target: '[data-tour="messages-compose-actions"]', titleKey: 'HELP_CENTER.TOUR.MESSAGES.COMPOSE_TITLE', contentKey: 'HELP_CENTER.TOUR.MESSAGES.COMPOSE_CONTENT', placement: 'bottom' },
      { target: '[data-tour="messages-compose-modal"]', titleKey: 'HELP_CENTER.TOUR.MESSAGES.COMPOSE_MODAL_TITLE', contentKey: 'HELP_CENTER.TOUR.MESSAGES.COMPOSE_MODAL_CONTENT', placement: 'bottom', before: openMessagesComposeModal, after: closeMessagesComposeModal },
      { target: '[data-tour="messages-source-filters"]', titleKey: 'HELP_CENTER.TOUR.MESSAGES.SOURCES_TITLE', contentKey: 'HELP_CENTER.TOUR.MESSAGES.SOURCES_CONTENT', placement: 'bottom' },
      { target: '[data-tour="messages-search"]', titleKey: 'HELP_CENTER.TOUR.MESSAGES.SEARCH_TITLE', contentKey: 'HELP_CENTER.TOUR.MESSAGES.SEARCH_CONTENT', placement: 'bottom' },
      { target: '[data-tour="messages-first-conversation"]', titleKey: 'HELP_CENTER.TOUR.MESSAGES.CONVERSATION_TITLE', contentKey: 'HELP_CENTER.TOUR.MESSAGES.CONVERSATION_CONTENT', placement: 'right' },
      { target: '[data-tour="messages-thread-header"]', titleKey: 'HELP_CENTER.TOUR.MESSAGES.THREAD_HEADER_TITLE', contentKey: 'HELP_CENTER.TOUR.MESSAGES.THREAD_HEADER_CONTENT', placement: 'bottom' },
      { target: '[data-tour="messages-thread"]', titleKey: 'HELP_CENTER.TOUR.MESSAGES.THREAD_TITLE', contentKey: 'HELP_CENTER.TOUR.MESSAGES.THREAD_CONTENT', placement: 'left' },
      { target: '[data-tour="messages-composer"]', titleKey: 'HELP_CENTER.TOUR.MESSAGES.REPLY_TITLE', contentKey: 'HELP_CENTER.TOUR.MESSAGES.REPLY_CONTENT', placement: 'top' }
    ]
  },
  {
    key: 'sales',
    titleKey: 'MAIN.SALES',
    descriptionKey: 'HELP_CENTER.MODULES.SALES.DESCRIPTION',
    route: '/sales',
    routePrefixes: ['/sales'],
    icon: 'shopping-cart',
    requiredPermission: 'sales.view',
    modes: ['gestion'],
    tourReadySelector: '[data-tour-ready="sales"]',
    sections: [
      'HELP_CENTER.MODULES.SALES.SECTIONS.REVIEW_ORDERS',
      'HELP_CENTER.MODULES.SALES.SECTIONS.CHECK_ATTRIBUTION',
      'HELP_CENTER.MODULES.SALES.SECTIONS.FOLLOW_POSTSALE'
    ],
    tourSteps: [
      {
        target: '[data-tour="sales-period-filters"]',
        titleKey: 'HELP_CENTER.TOUR.SALES.FILTERS_TITLE',
        contentKey: 'HELP_CENTER.TOUR.SALES.FILTERS_CONTENT',
        placement: 'bottom',
        skipBeacon: true
      },
      {
        target: '[data-tour="sales-list-controls"]',
        titleKey: 'HELP_CENTER.TOUR.SALES.SEARCH_SORT_TITLE',
        contentKey: 'HELP_CENTER.TOUR.SALES.SEARCH_SORT_CONTENT',
        placement: 'bottom'
      },
      {
        target: '[data-tour="sales-order-id"]',
        titleKey: 'HELP_CENTER.TOUR.SALES.ORDER_ID_TITLE',
        contentKey: 'HELP_CENTER.TOUR.SALES.ORDER_ID_CONTENT',
        placement: 'right'
      },
      {
        target: '[data-tour="sales-order-items"]',
        titleKey: 'HELP_CENTER.TOUR.SALES.ITEMS_TITLE',
        contentKey: 'HELP_CENTER.TOUR.SALES.ITEMS_CONTENT',
        placement: 'bottom'
      },
      {
        target: '[data-tour="sales-payment-status"]',
        titleKey: 'HELP_CENTER.TOUR.SALES.PAYMENT_TITLE',
        contentKey: 'HELP_CENTER.TOUR.SALES.PAYMENT_CONTENT',
        placement: 'bottom'
      },
      {
        target: '[data-tour="sales-shipping-status"]',
        titleKey: 'HELP_CENTER.TOUR.SALES.SHIPPING_TITLE',
        contentKey: 'HELP_CENTER.TOUR.SALES.SHIPPING_CONTENT',
        placement: 'bottom'
      },
      {
        target: '[data-tour="sales-attribution"]',
        titleKey: 'HELP_CENTER.TOUR.SALES.ATTRIBUTION_TITLE',
        contentKey: 'HELP_CENTER.TOUR.SALES.ATTRIBUTION_CONTENT',
        placement: 'left'
      },
      {
        target: '[data-tour="sales-pagination"]',
        titleKey: 'HELP_CENTER.TOUR.SALES.PAGINATION_TITLE',
        contentKey: 'HELP_CENTER.TOUR.SALES.PAGINATION_CONTENT',
        placement: 'top'
      }
    ]
  },
  {
    key: 'analisis',
    titleKey: 'MAIN.ANALISIS',
    descriptionKey: 'HELP_CENTER.MODULES.ANALISIS.DESCRIPTION',
    route: '/analisis',
    routePrefixes: ['/analisis'],
    icon: 'chart-line',
    requiredPermission: 'analisis.view',
    modes: ['gestion'],
    tourReadySelector: '[data-tour-ready="analisis"]',
    sections: [
      'HELP_CENTER.MODULES.ANALISIS.SECTIONS.FILTER_PERIODS',
      'HELP_CENTER.MODULES.ANALISIS.SECTIONS.REVIEW_PROJECTIONS',
      'HELP_CENTER.MODULES.ANALISIS.SECTIONS.COMPARE_CHANNELS'
    ],
    tourSteps: [
      { target: '[data-tour="analisis-filters"]', titleKey: 'HELP_CENTER.TOUR.ANALISIS.FILTERS_TITLE', contentKey: 'HELP_CENTER.TOUR.ANALISIS.FILTERS_CONTENT', placement: 'bottom', skipBeacon: true, before: () => setAnalisisTourTab('sales') },
      { target: '[data-tour="analisis-tabs"]', titleKey: 'HELP_CENTER.TOUR.ANALISIS.TABS_TITLE', contentKey: 'HELP_CENTER.TOUR.ANALISIS.TABS_CONTENT', placement: 'bottom' },
      { target: '[data-tour="analisis-projection"]', titleKey: 'HELP_CENTER.TOUR.ANALISIS.PROJECTION_TITLE', contentKey: 'HELP_CENTER.TOUR.ANALISIS.PROJECTION_CONTENT', placement: 'bottom', before: () => setAnalisisTourTab('sales') },
      { target: '[data-tour="analisis-income-type"]', titleKey: 'HELP_CENTER.TOUR.ANALISIS.INCOME_TITLE', contentKey: 'HELP_CENTER.TOUR.ANALISIS.INCOME_CONTENT', placement: 'top', before: () => setAnalisisTourTab('sales') }
    ]
  },
  {
    key: 'posts',
    titleKey: 'MAIN.POSTS',
    descriptionKey: 'HELP_CENTER.MODULES.POSTS.DESCRIPTION',
    route: '/posts',
    routePrefixes: ['/posts'],
    icon: 'file-invoice',
    requiredPermission: 'posts.view',
    modes: ['gestion'],
    tourReadySelector: '[data-tour-ready="posts"]',
    sections: [
      'HELP_CENTER.MODULES.POSTS.SECTIONS.REVIEW_LISTINGS',
      'HELP_CENTER.MODULES.POSTS.SECTIONS.EDIT_DETAILS',
      'HELP_CENTER.MODULES.POSTS.SECTIONS.TUNE_AUTOMATION'
    ],
    tourSteps: [
      {
        target: '[data-tour="posts-filters"]',
        titleKey: 'HELP_CENTER.TOUR.POSTS.FILTERS_TITLE',
        contentKey: 'HELP_CENTER.TOUR.POSTS.FILTERS_CONTENT',
        placement: 'bottom',
        skipBeacon: true,
        before: switchPostsToListMode
      },
      {
        target: '[data-tour="posts-status-tabs"]',
        titleKey: 'HELP_CENTER.TOUR.POSTS.STATUS_TITLE',
        contentKey: 'HELP_CENTER.TOUR.POSTS.STATUS_CONTENT',
        placement: 'bottom'
      },
      {
        target: '[data-tour="posts-search"]',
        titleKey: 'HELP_CENTER.TOUR.POSTS.SEARCH_TITLE',
        contentKey: 'HELP_CENTER.TOUR.POSTS.SEARCH_CONTENT',
        placement: 'bottom'
      },
      {
        target: '[data-tour="posts-bot-filter"]',
        titleKey: 'HELP_CENTER.TOUR.POSTS.BOT_FILTER_TITLE',
        contentKey: 'HELP_CENTER.TOUR.POSTS.BOT_FILTER_CONTENT',
        placement: 'bottom'
      },
      {
        target: '[data-tour="posts-sort-controls"]',
        titleKey: 'HELP_CENTER.TOUR.POSTS.SORT_TITLE',
        contentKey: 'HELP_CENTER.TOUR.POSTS.SORT_CONTENT',
        placement: 'bottom'
      },
      {
        target: '[data-tour="posts-layout-toggle"]',
        titleKey: 'HELP_CENTER.TOUR.POSTS.LAYOUT_TITLE',
        contentKey: 'HELP_CENTER.TOUR.POSTS.LAYOUT_CONTENT',
        placement: 'top'
      },
      {
        target: '[data-tour="posts-list-table"]',
        titleKey: 'HELP_CENTER.TOUR.POSTS.TABLE_TITLE',
        contentKey: 'HELP_CENTER.TOUR.POSTS.TABLE_CONTENT',
        placement: 'top'
      },
      {
        target: '[data-tour="posts-first-title"]',
        titleKey: 'HELP_CENTER.TOUR.POSTS.TITLE_TITLE',
        contentKey: 'HELP_CENTER.TOUR.POSTS.TITLE_CONTENT',
        placement: 'bottom'
      },
      {
        target: '[data-tour="posts-first-stock"]',
        titleKey: 'HELP_CENTER.TOUR.POSTS.STOCK_TITLE',
        contentKey: 'HELP_CENTER.TOUR.POSTS.STOCK_CONTENT',
        placement: 'bottom'
      },
      {
        target: '[data-tour="posts-first-ads"]',
        titleKey: 'HELP_CENTER.TOUR.POSTS.ADS_TITLE',
        contentKey: 'HELP_CENTER.TOUR.POSTS.ADS_CONTENT',
        placement: 'bottom'
      },
      {
        target: '[data-tour="posts-first-logistics"]',
        titleKey: 'HELP_CENTER.TOUR.POSTS.LOGISTICS_TITLE',
        contentKey: 'HELP_CENTER.TOUR.POSTS.LOGISTICS_CONTENT',
        placement: 'bottom'
      },
      {
        target: '[data-tour="posts-first-bot-toggle"]',
        titleKey: 'HELP_CENTER.TOUR.POSTS.BOT_TOGGLE_TITLE',
        contentKey: 'HELP_CENTER.TOUR.POSTS.BOT_TOGGLE_CONTENT',
        placement: 'left'
      },
      {
        target: '[data-tour="posts-first-select"]',
        titleKey: 'HELP_CENTER.TOUR.POSTS.SELECT_TITLE',
        contentKey: 'HELP_CENTER.TOUR.POSTS.SELECT_CONTENT',
        placement: 'right',
        before: () => selectFirstPostForTour(false)
      },
      {
        target: '[data-tour="posts-bulk-bot-actions"]',
        titleKey: 'HELP_CENTER.TOUR.POSTS.BULK_BOT_TITLE',
        contentKey: 'HELP_CENTER.TOUR.POSTS.BULK_BOT_CONTENT',
        placement: 'bottom',
        before: () => selectFirstPostForTour(true),
        after: () => selectFirstPostForTour(false)
      },
      {
        target: '[data-tour="posts-pagination"]',
        titleKey: 'HELP_CENTER.TOUR.POSTS.PAGINATION_TITLE',
        contentKey: 'HELP_CENTER.TOUR.POSTS.PAGINATION_CONTENT',
        placement: 'top'
      }
    ]
  },
  {
    key: 'stock',
    titleKey: 'MAIN.STOCK',
    descriptionKey: 'HELP_CENTER.MODULES.STOCK.DESCRIPTION',
    route: '/stock',
    routePrefixes: ['/stock'],
    icon: 'box',
    requiredPermission: 'stock.view',
    modes: ['gestion'],
    tourReadySelector: '[data-tour-ready="stock"]',
    sections: [
      'HELP_CENTER.MODULES.STOCK.SECTIONS.MONITOR_LEVELS',
      'HELP_CENTER.MODULES.STOCK.SECTIONS.PRIORITIZE_ALERTS',
      'HELP_CENTER.MODULES.STOCK.SECTIONS.OPEN_LISTINGS'
    ],
    tourSteps: [
      {
        target: '[data-tour="stock-filters"]',
        titleKey: 'HELP_CENTER.TOUR.STOCK.FILTERS_TITLE',
        contentKey: 'HELP_CENTER.TOUR.STOCK.FILTERS_CONTENT',
        placement: 'bottom',
        skipBeacon: true
      },
      {
        target: '[data-tour="stock-first-publication"]',
        titleKey: 'HELP_CENTER.TOUR.STOCK.PUBLICATION_TITLE',
        contentKey: 'HELP_CENTER.TOUR.STOCK.PUBLICATION_CONTENT',
        placement: 'right'
      },
      {
        target: '[data-tour="stock-first-quantity"]',
        titleKey: 'HELP_CENTER.TOUR.STOCK.QUANTITY_TITLE',
        contentKey: 'HELP_CENTER.TOUR.STOCK.QUANTITY_CONTENT',
        placement: 'bottom'
      },
      {
        target: '[data-tour="stock-first-locations"]',
        titleKey: 'HELP_CENTER.TOUR.STOCK.LOCATIONS_TITLE',
        contentKey: 'HELP_CENTER.TOUR.STOCK.LOCATIONS_CONTENT',
        placement: 'bottom'
      },
      {
        target: '[data-tour="stock-first-threshold"]',
        titleKey: 'HELP_CENTER.TOUR.STOCK.THRESHOLD_TITLE',
        contentKey: 'HELP_CENTER.TOUR.STOCK.THRESHOLD_CONTENT',
        placement: 'left'
      },
      {
        target: '[data-tour="stock-thresholds"]',
        titleKey: 'HELP_CENTER.TOUR.STOCK.THRESHOLDS_TITLE',
        contentKey: 'HELP_CENTER.TOUR.STOCK.THRESHOLDS_CONTENT',
        placement: 'top'
      }
    ]
  },
  {
    key: 'claims',
    titleKey: 'MAIN.CLAIMS',
    descriptionKey: 'HELP_CENTER.MODULES.CLAIMS.DESCRIPTION',
    route: '/claims',
    routePrefixes: ['/claims'],
    icon: 'exclamation-circle',
    requiredPermission: 'claims.view',
    modes: ['gestion'],
    tourReadySelector: '[data-tour-ready="claims"]',
    sections: [
      'HELP_CENTER.MODULES.CLAIMS.SECTIONS.PRIORITIZE_OPEN',
      'HELP_CENTER.MODULES.CLAIMS.SECTIONS.FILTER_STATUS',
      'HELP_CENTER.MODULES.CLAIMS.SECTIONS.OPEN_RELATED_SALES'
    ],
    tourSteps: [
      { target: '[data-tour="claims-summary"]', titleKey: 'HELP_CENTER.TOUR.CLAIMS.SUMMARY_TITLE', contentKey: 'HELP_CENTER.TOUR.CLAIMS.SUMMARY_CONTENT', placement: 'bottom', skipBeacon: true },
      { target: '[data-tour="claims-filters"]', titleKey: 'HELP_CENTER.TOUR.CLAIMS.FILTERS_TITLE', contentKey: 'HELP_CENTER.TOUR.CLAIMS.FILTERS_CONTENT', placement: 'bottom' },
      { target: '[data-tour="claims-table"]', titleKey: 'HELP_CENTER.TOUR.CLAIMS.TABLE_TITLE', contentKey: 'HELP_CENTER.TOUR.CLAIMS.TABLE_CONTENT', placement: 'top' },
      { target: '[data-tour="claims-first-priority"]', titleKey: 'HELP_CENTER.TOUR.CLAIMS.PRIORITY_TITLE', contentKey: 'HELP_CENTER.TOUR.CLAIMS.PRIORITY_CONTENT', placement: 'bottom' },
      { target: '[data-tour="claims-first-stage"]', titleKey: 'HELP_CENTER.TOUR.CLAIMS.STAGE_TITLE', contentKey: 'HELP_CENTER.TOUR.CLAIMS.STAGE_CONTENT', placement: 'bottom' },
      { target: '[data-tour="claims-first-row"]', titleKey: 'HELP_CENTER.TOUR.CLAIMS.DETAIL_TITLE', contentKey: 'HELP_CENTER.TOUR.CLAIMS.DETAIL_CONTENT', placement: 'bottom' },
      { target: '[data-tour="claims-pagination"]', titleKey: 'HELP_CENTER.TOUR.CLAIMS.PAGINATION_TITLE', contentKey: 'HELP_CENTER.TOUR.CLAIMS.PAGINATION_CONTENT', placement: 'top' }
    ]
  },
  {
    key: 'calendar',
    titleKey: 'MAIN.CALENDAR',
    descriptionKey: 'HELP_CENTER.MODULES.CALENDAR.DESCRIPTION',
    route: '/calendar',
    routePrefixes: ['/calendar'],
    icon: 'calendar-alt',
    requiredPermission: 'calendar.view',
    modes: ['gestion'],
    tourReadySelector: '[data-tour-ready="calendar"]',
    sections: [
      'HELP_CENTER.MODULES.CALENDAR.SECTIONS.REVIEW_EVENTS',
      'HELP_CENTER.MODULES.CALENDAR.SECTIONS.FILTER_TYPES',
      'HELP_CENTER.MODULES.CALENDAR.SECTIONS.CREATE_MANUAL_EVENTS'
    ],
    tourSteps: [
      { target: '[data-tour="calendar-summary"]', titleKey: 'HELP_CENTER.TOUR.CALENDAR.SUMMARY_TITLE', contentKey: 'HELP_CENTER.TOUR.CALENDAR.SUMMARY_CONTENT', placement: 'bottom', skipBeacon: true },
      { target: '[data-tour="calendar-navigation"]', titleKey: 'HELP_CENTER.TOUR.CALENDAR.NAVIGATION_TITLE', contentKey: 'HELP_CENTER.TOUR.CALENDAR.NAVIGATION_CONTENT', placement: 'bottom' },
      { target: '[data-tour="calendar-actions"]', titleKey: 'HELP_CENTER.TOUR.CALENDAR.ACTIONS_TITLE', contentKey: 'HELP_CENTER.TOUR.CALENDAR.ACTIONS_CONTENT', placement: 'bottom' },
      { target: '[data-tour="calendar-event-modal"]', titleKey: 'HELP_CENTER.TOUR.CALENDAR.MODAL_TITLE', contentKey: 'HELP_CENTER.TOUR.CALENDAR.MODAL_CONTENT', placement: 'bottom', before: openCalendarEventModal, after: closeCalendarEventModal },
      { target: '[data-tour="calendar-type-filters"]', titleKey: 'HELP_CENTER.TOUR.CALENDAR.FILTERS_TITLE', contentKey: 'HELP_CENTER.TOUR.CALENDAR.FILTERS_CONTENT', placement: 'bottom' },
      { target: '[data-tour="calendar-grid"]', titleKey: 'HELP_CENTER.TOUR.CALENDAR.GRID_TITLE', contentKey: 'HELP_CENTER.TOUR.CALENDAR.GRID_CONTENT', placement: 'top' },
      { target: '[data-tour="calendar-upcoming"]', titleKey: 'HELP_CENTER.TOUR.CALENDAR.UPCOMING_TITLE', contentKey: 'HELP_CENTER.TOUR.CALENDAR.UPCOMING_CONTENT', placement: 'left' },
      { target: '[data-tour="calendar-detail"]', titleKey: 'HELP_CENTER.TOUR.CALENDAR.DETAIL_TITLE', contentKey: 'HELP_CENTER.TOUR.CALENDAR.DETAIL_CONTENT', placement: 'left' }
    ]
  },
  {
    key: 'integrations',
    titleKey: 'MAIN.INTEGRATIONS',
    descriptionKey: 'HELP_CENTER.MODULES.INTEGRATIONS.DESCRIPTION',
    route: '/integrations',
    routePrefixes: ['/integrations'],
    icon: 'plug',
    requiredPermission: 'integrations.view',
    modes: ['gestion'],
    tourReadySelector: '[data-tour-ready="integrations"]',
    sections: [
      'HELP_CENTER.MODULES.INTEGRATIONS.SECTIONS.CONNECT_ACCOUNT',
      'HELP_CENTER.MODULES.INTEGRATIONS.SECTIONS.SWITCH_CONTEXT',
      'HELP_CENTER.MODULES.INTEGRATIONS.SECTIONS.CHECK_STATUS'
    ],
    tourSteps: [
      { target: '[data-tour="integrations-provider-card"]', titleKey: 'HELP_CENTER.TOUR.INTEGRATIONS.PROVIDER_TITLE', contentKey: 'HELP_CENTER.TOUR.INTEGRATIONS.PROVIDER_CONTENT', placement: 'bottom', skipBeacon: true },
      { target: '[data-tour="integrations-account-summary"]', titleKey: 'HELP_CENTER.TOUR.INTEGRATIONS.SUMMARY_TITLE', contentKey: 'HELP_CENTER.TOUR.INTEGRATIONS.SUMMARY_CONTENT', placement: 'bottom' },
      { target: '[data-tour="integrations-connected-accounts"]', titleKey: 'HELP_CENTER.TOUR.INTEGRATIONS.ACCOUNTS_TITLE', contentKey: 'HELP_CENTER.TOUR.INTEGRATIONS.ACCOUNTS_CONTENT', placement: 'bottom' },
      { target: '[data-tour="integrations-account-actions"]', titleKey: 'HELP_CENTER.TOUR.INTEGRATIONS.ACCOUNT_ACTIONS_TITLE', contentKey: 'HELP_CENTER.TOUR.INTEGRATIONS.ACCOUNT_ACTIONS_CONTENT', placement: 'left' },
      { target: '[data-tour="integrations-main-actions"]', titleKey: 'HELP_CENTER.TOUR.INTEGRATIONS.MAIN_ACTIONS_TITLE', contentKey: 'HELP_CENTER.TOUR.INTEGRATIONS.MAIN_ACTIONS_CONTENT', placement: 'top' },
      { target: '[data-tour="integrations-used-by"]', titleKey: 'HELP_CENTER.TOUR.INTEGRATIONS.USED_BY_TITLE', contentKey: 'HELP_CENTER.TOUR.INTEGRATIONS.USED_BY_CONTENT', placement: 'left' }
    ]
  },
  {
    key: 'agents',
    titleKey: 'MAIN.AGENTS',
    descriptionKey: 'HELP_CENTER.MODULES.AGENTS.DESCRIPTION',
    route: '/agents',
    routePrefixes: ['/agents'],
    icon: 'robot',
    requiredPermission: 'agents.view',
    modes: ['gestion'],
    tourReadySelector: '[data-tour-ready="agents"]',
    sections: [
      'HELP_CENTER.MODULES.AGENTS.SECTIONS.CHOOSE_AGENT',
      'HELP_CENTER.MODULES.AGENTS.SECTIONS.CONFIGURE_BEHAVIOR',
      'HELP_CENTER.MODULES.AGENTS.SECTIONS.TEST_BEFORE_LIVE'
    ],
    tourSteps: [
      { target: '[data-tour="agents-create-actions"]', titleKey: 'HELP_CENTER.TOUR.AGENTS.CREATE_TITLE', contentKey: 'HELP_CENTER.TOUR.AGENTS.CREATE_CONTENT', placement: 'bottom', skipBeacon: true },
      { target: '[data-tour="agents-list"]', titleKey: 'HELP_CENTER.TOUR.AGENTS.LIST_TITLE', contentKey: 'HELP_CENTER.TOUR.AGENTS.LIST_CONTENT', placement: 'bottom' },
      { target: '[data-tour="agents-first-agent"]', titleKey: 'HELP_CENTER.TOUR.AGENTS.AGENT_TITLE', contentKey: 'HELP_CENTER.TOUR.AGENTS.AGENT_CONTENT', placement: 'bottom' },
      { target: '[data-tour="agents-first-agent-stats"]', titleKey: 'HELP_CENTER.TOUR.AGENTS.STATS_TITLE', contentKey: 'HELP_CENTER.TOUR.AGENTS.STATS_CONTENT', placement: 'left' },
      { target: '[data-tour="agents-first-agent-actions"]', titleKey: 'HELP_CENTER.TOUR.AGENTS.ACTIONS_TITLE', contentKey: 'HELP_CENTER.TOUR.AGENTS.ACTIONS_CONTENT', placement: 'left' },
      { target: '[data-tour="agents-detail-header"]', titleKey: 'HELP_CENTER.TOUR.AGENTS.DETAIL_TITLE', contentKey: 'HELP_CENTER.TOUR.AGENTS.DETAIL_CONTENT', placement: 'bottom' },
      { target: '[data-tour="agents-detail-tabs"]', titleKey: 'HELP_CENTER.TOUR.AGENTS.TABS_TITLE', contentKey: 'HELP_CENTER.TOUR.AGENTS.TABS_CONTENT', placement: 'bottom' },
      { target: '[data-tour="agents-detail-actions"]', titleKey: 'HELP_CENTER.TOUR.AGENTS.DETAIL_ACTIONS_TITLE', contentKey: 'HELP_CENTER.TOUR.AGENTS.DETAIL_ACTIONS_CONTENT', placement: 'left' }
    ]
  },
  {
    key: 'access',
    titleKey: 'MAIN.ACCESS',
    descriptionKey: 'HELP_CENTER.MODULES.ACCESS.DESCRIPTION',
    route: '/users',
    routePrefixes: ['/users', '/profiles'],
    icon: 'users',
    requiredAnyPermissions: ['users.view', 'profiles.view', 'activity.view'],
    modes: ['gestion'],
    tourReadySelector: '[data-tour-ready="access"]',
    sections: [
      'HELP_CENTER.MODULES.ACCESS.SECTIONS.INVITE_USERS',
      'HELP_CENTER.MODULES.ACCESS.SECTIONS.ASSIGN_PROFILES',
      'HELP_CENTER.MODULES.ACCESS.SECTIONS.AUDIT_ACTIVITY'
    ],
    tourSteps: [
      { target: '[data-tour="access-create-user"]', titleKey: 'HELP_CENTER.TOUR.ACCESS.CREATE_USER_TITLE', contentKey: 'HELP_CENTER.TOUR.ACCESS.CREATE_USER_CONTENT', placement: 'bottom', skipBeacon: true },
      { target: '[data-tour="access-user-modal"]', titleKey: 'HELP_CENTER.TOUR.ACCESS.USER_MODAL_TITLE', contentKey: 'HELP_CENTER.TOUR.ACCESS.USER_MODAL_CONTENT', placement: 'bottom', before: openAccessUserModal, after: closeAccessUserModal },
      { target: '[data-tour="access-users-list"]', titleKey: 'HELP_CENTER.TOUR.ACCESS.USERS_TITLE', contentKey: 'HELP_CENTER.TOUR.ACCESS.USERS_CONTENT', placement: 'bottom' },
      { target: '[data-tour="access-first-user"]', titleKey: 'HELP_CENTER.TOUR.ACCESS.USER_TITLE', contentKey: 'HELP_CENTER.TOUR.ACCESS.USER_CONTENT', placement: 'bottom' },
      { target: '[data-tour="access-user-profile"]', titleKey: 'HELP_CENTER.TOUR.ACCESS.PROFILE_TITLE', contentKey: 'HELP_CENTER.TOUR.ACCESS.PROFILE_CONTENT', placement: 'bottom' },
      { target: '[data-tour="access-user-actions"]', titleKey: 'HELP_CENTER.TOUR.ACCESS.ACTIONS_TITLE', contentKey: 'HELP_CENTER.TOUR.ACCESS.ACTIONS_CONTENT', placement: 'left' },
      { target: '[data-tour="access-profiles-list"]', titleKey: 'HELP_CENTER.TOUR.ACCESS.PROFILES_TITLE', contentKey: 'HELP_CENTER.TOUR.ACCESS.PROFILES_CONTENT', placement: 'bottom' },
      { target: '[data-tour="access-profile-permissions"]', titleKey: 'HELP_CENTER.TOUR.ACCESS.PERMISSIONS_TITLE', contentKey: 'HELP_CENTER.TOUR.ACCESS.PERMISSIONS_CONTENT', placement: 'bottom' }
    ]
  },
  {
    key: 'activity',
    titleKey: 'MAIN.ACTIVITY',
    descriptionKey: 'HELP_CENTER.MODULES.ACTIVITY.DESCRIPTION',
    route: '/activity',
    routePrefixes: ['/activity'],
    icon: 'list-alt',
    requiredPermission: 'activity.view',
    modes: ['gestion'],
    tourReadySelector: '[data-tour-ready="activity"]',
    sections: [
      'HELP_CENTER.MODULES.ACTIVITY.SECTIONS.FILTER_CHANGES',
      'HELP_CENTER.MODULES.ACTIVITY.SECTIONS.REVIEW_MODULES',
      'HELP_CENTER.MODULES.ACTIVITY.SECTIONS.TRACE_USERS'
    ],
    tourSteps: [
      { target: '[data-tour="activity-summary"]', titleKey: 'HELP_CENTER.TOUR.ACTIVITY.SUMMARY_TITLE', contentKey: 'HELP_CENTER.TOUR.ACTIVITY.SUMMARY_CONTENT', placement: 'bottom', skipBeacon: true },
      { target: '[data-tour="activity-filters"]', titleKey: 'HELP_CENTER.TOUR.ACTIVITY.FILTERS_TITLE', contentKey: 'HELP_CENTER.TOUR.ACTIVITY.FILTERS_CONTENT', placement: 'bottom' },
      { target: '[data-tour="activity-modules"]', titleKey: 'HELP_CENTER.TOUR.ACTIVITY.MODULES_TITLE', contentKey: 'HELP_CENTER.TOUR.ACTIVITY.MODULES_CONTENT', placement: 'top' },
      { target: '[data-tour="activity-log"]', titleKey: 'HELP_CENTER.TOUR.ACTIVITY.LOG_TITLE', contentKey: 'HELP_CENTER.TOUR.ACTIVITY.LOG_CONTENT', placement: 'top' }
    ]
  },
  {
    key: 'price_calculator',
    titleKey: 'PRICE_CALCULATOR.PAGE_TITLE',
    descriptionKey: 'HELP_CENTER.MODULES.PRICE_CALCULATOR.DESCRIPTION',
    route: '/price-calculator',
    routePrefixes: ['/price-calculator'],
    icon: 'calculator',
    requiredPermission: 'price_calculator.view',
    modes: ['gestion'],
    tourReadySelector: '[data-tour-ready="price-calculator"]',
    sections: [
      'HELP_CENTER.MODULES.PRICE_CALCULATOR.SECTIONS.DEFINE_OBJECTIVE',
      'HELP_CENTER.MODULES.PRICE_CALCULATOR.SECTIONS.ADD_COSTS',
      'HELP_CENTER.MODULES.PRICE_CALCULATOR.SECTIONS.READ_MARGIN'
    ],
    tourSteps: [
      { target: '[data-tour="price-calculator-modes"]', titleKey: 'HELP_CENTER.TOUR.PRICE_CALCULATOR.MODES_TITLE', contentKey: 'HELP_CENTER.TOUR.PRICE_CALCULATOR.MODES_CONTENT', placement: 'bottom', skipBeacon: true },
      { target: '[data-tour="price-calculator-objective"]', titleKey: 'HELP_CENTER.TOUR.PRICE_CALCULATOR.OBJECTIVE_TITLE', contentKey: 'HELP_CENTER.TOUR.PRICE_CALCULATOR.OBJECTIVE_CONTENT', placement: 'bottom' },
      { target: '[data-tour="price-calculator-save-tabs"]', titleKey: 'HELP_CENTER.TOUR.PRICE_CALCULATOR.SAVE_TABS_TITLE', contentKey: 'HELP_CENTER.TOUR.PRICE_CALCULATOR.SAVE_TABS_CONTENT', placement: 'bottom', before: () => setPriceCalculatorSaveTab('product'), after: () => setPriceCalculatorSaveTab('general') },
      { target: '[data-tour="price-calculator-costs"]', titleKey: 'HELP_CENTER.TOUR.PRICE_CALCULATOR.COSTS_TITLE', contentKey: 'HELP_CENTER.TOUR.PRICE_CALCULATOR.COSTS_CONTENT', placement: 'bottom' },
      { target: '[data-tour="price-calculator-platform"]', titleKey: 'HELP_CENTER.TOUR.PRICE_CALCULATOR.PLATFORM_TITLE', contentKey: 'HELP_CENTER.TOUR.PRICE_CALCULATOR.PLATFORM_CONTENT', placement: 'bottom' },
      { target: '[data-tour="price-calculator-ml-query"]', titleKey: 'HELP_CENTER.TOUR.PRICE_CALCULATOR.ML_TITLE', contentKey: 'HELP_CENTER.TOUR.PRICE_CALCULATOR.ML_CONTENT', placement: 'bottom' },
      { target: '[data-tour="price-calculator-taxes"]', titleKey: 'HELP_CENTER.TOUR.PRICE_CALCULATOR.TAXES_TITLE', contentKey: 'HELP_CENTER.TOUR.PRICE_CALCULATOR.TAXES_CONTENT', placement: 'bottom' },
      { target: '[data-tour="price-calculator-results"]', titleKey: 'HELP_CENTER.TOUR.PRICE_CALCULATOR.RESULTS_TITLE', contentKey: 'HELP_CENTER.TOUR.PRICE_CALCULATOR.RESULTS_CONTENT', placement: 'left' }
    ]
  },
  {
    key: 'subscription',
    titleKey: 'MAIN.SUBSCRIPTION',
    descriptionKey: 'HELP_CENTER.MODULES.SUBSCRIPTION.DESCRIPTION',
    route: '/subscription',
    routePrefixes: ['/subscription'],
    icon: 'credit-card',
    requiredPermission: 'subscription.view',
    modes: ['gestion'],
    tourReadySelector: '[data-tour-ready="subscription"]',
    sections: [
      'HELP_CENTER.MODULES.SUBSCRIPTION.SECTIONS.CHECK_STATUS',
      'HELP_CENTER.MODULES.SUBSCRIPTION.SECTIONS.REVIEW_USAGE',
      'HELP_CENTER.MODULES.SUBSCRIPTION.SECTIONS.MANAGE_PLAN'
    ],
    tourSteps: [
      { target: '[data-tour="subscription-status"]', titleKey: 'HELP_CENTER.TOUR.SUBSCRIPTION.STATUS_TITLE', contentKey: 'HELP_CENTER.TOUR.SUBSCRIPTION.STATUS_CONTENT', placement: 'bottom', skipBeacon: true },
      { target: '[data-tour="subscription-usage"]', titleKey: 'HELP_CENTER.TOUR.SUBSCRIPTION.USAGE_TITLE', contentKey: 'HELP_CENTER.TOUR.SUBSCRIPTION.USAGE_CONTENT', placement: 'bottom' },
      { target: '[data-tour="subscription-plans"]', titleKey: 'HELP_CENTER.TOUR.SUBSCRIPTION.PLANS_TITLE', contentKey: 'HELP_CENTER.TOUR.SUBSCRIPTION.PLANS_CONTENT', placement: 'bottom' }
    ]
  },
  {
    key: 'sales_workspace',
    titleKey: 'SALES.MENU',
    descriptionKey: 'HELP_CENTER.MODULES.SALES_WORKSPACE.DESCRIPTION',
    route: '/sales/dashboard',
    routePrefixes: ['/sales/dashboard', '/sales/pipeline', '/sales/tasks', '/sales/accounts-to-activate', '/sales/promo', '/sales/reports', '/sales/waitlist', '/sales/companies', '/sales/company', '/sales/opportunity'],
    icon: 'chart-line',
    requiredAnyPermissions: ['crm.view', 'pipeline.view', 'tasks.view', 'waitlist.view', 'sales_reports.view', 'promo.view'],
    modes: ['sales'],
    sections: [
      'HELP_CENTER.MODULES.SALES_WORKSPACE.SECTIONS.REVIEW_DASHBOARD',
      'HELP_CENTER.MODULES.SALES_WORKSPACE.SECTIONS.MOVE_PIPELINE',
      'HELP_CENTER.MODULES.SALES_WORKSPACE.SECTIONS.COMPLETE_TASKS'
    ]
  }
];

const hasAccessToHelpModule = (module, auth) => {
  if (module.requiresSuperAdmin && !auth.isSuperAdmin()) {
    return false;
  }
  if (Array.isArray(module.modes) && module.modes.length && !module.modes.includes(auth.getCurrentWorkspaceMode())) {
    return false;
  }
  if (module.requiredPermission && !auth.hasPermission(module.requiredPermission)) {
    return false;
  }
  if (module.requiredAnyPermissions && !auth.hasAnyPermission(module.requiredAnyPermissions)) {
    return false;
  }
  return true;
};

const getVisibleHelpModules = auth =>
  HELP_MODULES.filter(module => hasAccessToHelpModule(module, auth));

const getHelpModulesForMode = auth =>
  HELP_MODULES.filter(module => {
    if (module.requiresSuperAdmin && !auth.isSuperAdmin()) {
      return false;
    }
    return !Array.isArray(module.modes) ||
      !module.modes.length ||
      module.modes.includes(auth.getCurrentWorkspaceMode());
  });

const getHelpModulesWithAccess = auth =>
  getHelpModulesForMode(auth).map(module => ({
    ...module,
    hasAccess: hasAccessToHelpModule(module, auth)
  }));

const findHelpModuleByKey = key =>
  HELP_MODULES.find(module => module.key === key);

const findHelpModuleByPath = pathname => {
  const matches = HELP_MODULES
    .flatMap(module =>
      module.routePrefixes
        .filter(prefix => pathname === prefix || pathname.startsWith(`${prefix}/`))
        .map(prefix => ({ module, prefix }))
    )
    .sort((a, b) => b.prefix.length - a.prefix.length);

  return matches[0]?.module;
};

const buildModuleTourSteps = (t, module) =>
  (module.tourSteps || []).map(step => ({
    ...step,
    title: t(step.titleKey),
    content: t(step.contentKey)
  }));

const buildHelpManualTourSteps = (t, module) => [
  {
    target: '[data-tour="help-featured-module"]',
    title: t('HELP_CENTER.TOUR.MANUAL_TITLE', { module: t(module.titleKey) }),
    content: t('HELP_CENTER.TOUR.MANUAL_CONTENT'),
    placement: 'bottom',
    skipBeacon: true
  },
  {
    target: '[data-tour="help-module-list"]',
    title: t('HELP_CENTER.TOUR.MODULE_LIST_TITLE'),
    content: t('HELP_CENTER.TOUR.MODULE_LIST_CONTENT'),
    placement: 'top'
  },
  {
    target: '[data-tour="top-actions"]',
    title: t('HELP_CENTER.TOUR.HELP_ACTIONS_TITLE'),
    content: t('HELP_CENTER.TOUR.HELP_ACTIONS_CONTENT'),
    placement: 'bottom-end'
  }
];

export {
  HELP_MODULES,
  buildHelpManualTourSteps,
  buildModuleTourSteps,
  findHelpModuleByKey,
  findHelpModuleByPath,
  getHelpModulesForMode,
  getHelpModulesWithAccess,
  getVisibleHelpModules,
  hasAccessToHelpModule
};
